module.exports = __webpack_public_path__ + "fonts/VideoJS.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/video.js/dist/font/VideoJS.eot
// module id = 132
// module chunks = 0